export const normalizeCardId = (cardId: string) => (cardId.startsWith('card-x') ? cardId : `card-x${cardId}`);
